export const transactionStatusData = [
    {
        option: 'ACCEPTED',
        value: 'ACCEPTED',
        css: 'green'
    },
    {
        option: 'NOT AUTOSAVED',
        value: 'NOT_AUTOSAVED',
        css: 'blue'
    },
    {
        option: 'FAILED',
        value: 'FAILED',
        css: 'red'
    },
    {
        option: 'IN PROGRESS',
        value: 'IN_PROGRESS',
        css: 'orange'
    },
    {
        option: '',
        value: 'UNKNOWN',
        hidden: true
    }
];